"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lodash_1 = __importDefault(require("lodash"));
const react_router_1 = require("react-router");
const strings_1 = require("../../../../../constants/strings");
const uiConstants_1 = require("../../../../../constants/uiConstants");
const paymentQuery_1 = require("../../../../../queries/paymentQuery");
const userQuery_1 = require("../../../../../queries/userQuery");
const walletQuery_1 = require("../../../../../queries/walletQuery");
const dateUtils_1 = require("../../../../../utils/dateUtils");
const zustandStore_1 = require("../../../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../../../atoms/button/simpleButton"));
const drawerAside_1 = __importDefault(require("../../../../organisms/drawerAside"));
const virtualCard_1 = require("../../../request/virtualCard");
const bouncingLoaderComp_1 = __importDefault(require("../../component/bouncingLoaderComp"));
const cardDetails_1 = __importDefault(require("./cardDetails"));
const fullName = (user = {}) => {
    const firstName = user.firstName || '';
    const lastName = user.lastName || '';
    if (!firstName && !lastName) {
        return lodash_1.default.escape(user.email);
    }
    let fullName = firstName + ' ';
    fullName = fullName + lastName;
    return lodash_1.default.escape(fullName);
};
const WalletDetailAside = () => {
    const navigate = (0, react_router_1.useNavigate)();
    const theme = (0, material_1.useTheme)();
    const { setDialog, setNotification, user, aside, setIsWalletCardDetailAsideOpen, setWalletPreviousPath } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const { walletCardDetailAside } = aside;
    const card = walletCardDetailAside.cardDetail;
    const { data: approver, isLoading: isGetApproverLoading } = (0, react_query_1.useQuery)((0, userQuery_1.userByIdQuery)(card?.assigner));
    const teamId = (0, zustandStore_1.useZustand)(state => state.team.teamId);
    const { data: sourceCard, isLoading: isSourceCardLoading } = (0, paymentQuery_1.useGetCardSourceQuery)({
        cardSourceId: card?.card?.sourceId || '',
        teamId,
        includeCardHolder: false,
    });
    const cancelVirtualCardQuery = (0, walletQuery_1.useCancelVirtualCardMutationQuery)();
    const handleCancelRequest = () => {
        cancelVirtualCardQuery.mutate({
            teamId: card?.context?.request.requester?.teamId,
            userId: user?.userId,
            isCardOwner: user?.userId === card?.context?.request.requester.userId || false,
            subjectId: card?.subjectId || '',
            virtualCardId: card?.request?.virtualCardId,
        }, {
            onSettled: () => {
                setIsWalletCardDetailAsideOpen(false);
            },
        });
    };
    const openConfirmCancelCardAside = () => {
        if (!card?.subjectId || !card.card?.id) {
            return;
        }
        if (card.card?.status !== 'ACTIVE') {
            setNotification([
                {
                    type: strings_1.notificationStrings.WARNING,
                    message: strings_1.walletStrings.CANCEL_CARD_ERROR,
                },
            ]);
            return;
        }
        setDialog({
            message: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                ? strings_1.walletStrings.HSBC_CANCEL_CARD_MESSAGE_TEXT
                : strings_1.walletStrings.CANCEL_CARD_MESSAGE_TEXT,
            type: strings_1.notificationStrings.WARNING,
            open: true,
            actionText: 'YES, Cancel Card',
            showCancel: true,
            onAccept: handleCancelRequest,
        });
    };
    const footerButtons = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "viewCardActivity-btn", color: uiConstants_1.UI_BUTTON_PRIMARY, style: { marginBottom: theme.tsGoUnit.tsUnitHalf }, onClick: () => {
                    setWalletPreviousPath(location.pathname);
                    setIsWalletCardDetailAsideOpen(false);
                    void navigate(`/wallet/${card?.id}`);
                }, label: strings_1.walletStrings.VIEW_CARD_ACTIVITY_BUTTON }), card?.card?.status === 'ACTIVE' && ((0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "cancelCard-btn", color: uiConstants_1.UI_BUTTON_SECONDARY, style: { marginBottom: theme.tsGoUnit.tsUnitHalf }, onClick: () => openConfirmCancelCardAside(), label: strings_1.walletStrings.CANCEL_CARD_BUTTON }))] }));
    return ((0, jsx_runtime_1.jsx)(drawerAside_1.default, { id: "wallet-detail", title: 'Card Details', open: walletCardDetailAside.isOpen, onClose: () => setIsWalletCardDetailAsideOpen(false), footerButtons: footerButtons, children: (0, jsx_runtime_1.jsxs)(material_1.Stack, { sx: [
                {
                    padding: theme.tsGoUnit.tsUnitHalf,
                    flexDirection: 'column',
                    display: 'flex',
                    flex: '1',
                },
                globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                    ? {
                        padding: 0,
                    }
                    : {},
            ], "data-testid": "wallet-detail-content", children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { sx: [
                                {
                                    textTransform: 'uppercase',
                                },
                                globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                    ? {
                                        fontWeight: 500,
                                        fontSize: '12px',
                                        color: '#000000',
                                        textTransform: 'none',
                                    }
                                    : {},
                            ], variant: "subtitle2", children: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? strings_1.walletStrings.BUSINESS_JUSTIFICATION
                                : strings_1.walletStrings.CARD_NAME }), (0, jsx_runtime_1.jsx)(material_1.Typography, { "data-testid": "card-name", variant: "body1", children: card?.context?.request.title || '' })] }), (0, jsx_runtime_1.jsx)(material_1.Stack, { sx: theme => ({
                        padding: `${theme.tsGoUnit.tsUnitHalf} 0 `,
                    }), children: card && (0, jsx_runtime_1.jsx)(cardDetails_1.default, { task: card }, card?.id) }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { sx: theme => ({
                        padding: `0 ${theme.tsGoUnit.tsUnitHalf} ${theme.tsGoUnit.tsUnitHalf} ${theme.tsGoUnit.tsUnitHalf} `,
                    }), children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { sx: [
                                {
                                    textTransform: 'uppercase',
                                },
                                globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                    ? {
                                        fontWeight: 500,
                                        fontSize: '12px',
                                        color: '#000000',
                                        textTransform: 'none',
                                    }
                                    : {},
                            ], variant: "subtitle2", children: strings_1.walletStrings.CARDHOLDER_NAME_FIELD_TEXT }), (0, jsx_runtime_1.jsx)(material_1.Typography, { "data-testid": "requester-name", variant: "body1", children: card?.request?.requester ? fullName(card.request.requester) : 'N/A' })] }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { sx: { padding: theme.tsGoUnit.tsUnitHalf }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { sx: [
                                {
                                    textTransform: 'uppercase',
                                },
                                globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                    ? {
                                        fontWeight: 500,
                                        fontSize: '12px',
                                        color: '#000000',
                                        textTransform: 'none',
                                    }
                                    : {},
                            ], variant: "subtitle2", children: strings_1.walletStrings.ISSUED_ON_FIELD_TEXT }), (0, jsx_runtime_1.jsx)(material_1.Typography, { "data-testid": "issued-on", variant: "body1", children: card?.assignedOn ? (0, dateUtils_1.formatDate)(new Date(card.assignedOn), user.language) : 'N/A' })] }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { sx: { padding: theme.tsGoUnit.tsUnitHalf }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { sx: [
                                {
                                    textTransform: 'uppercase',
                                },
                                globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                    ? {
                                        fontWeight: 500,
                                        fontSize: '12px',
                                        color: '#000000',
                                        textTransform: 'none',
                                    }
                                    : {},
                            ], variant: "subtitle2", children: strings_1.walletStrings.APPROVED_BY_FIELD_TEXT }), approver?.email ? ((0, jsx_runtime_1.jsx)(material_1.Typography, { "data-testid": "approver-email", variant: "body1", children: approver?.email })) : isGetApproverLoading ? ((0, jsx_runtime_1.jsx)(bouncingLoaderComp_1.default, {})) : ((0, jsx_runtime_1.jsx)(material_1.Typography, { sx: [
                                {
                                    textTransform: 'uppercase',
                                },
                                globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                    ? {
                                        fontWeight: 400,
                                        fontSize: '12px',
                                        color: '#000000',
                                        textTransform: 'none',
                                    }
                                    : {},
                            ], variant: "body1", children: "N/A" }))] }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { sx: { padding: theme.tsGoUnit.tsUnitHalf }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { sx: [
                                {
                                    textTransform: 'uppercase',
                                },
                                globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                    ? {
                                        fontWeight: 500,
                                        fontSize: '12px',
                                        color: '#000000',
                                        textTransform: 'none',
                                    }
                                    : {},
                            ], variant: "subtitle2", children: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? strings_1.walletStrings.HSBC_PHYSICAL_CARD_NAME_FIELD_TEXT
                                : strings_1.walletStrings.SOURCE_CARD_NAME_FIELD_TEXT }), sourceCard?.name ? ((0, jsx_runtime_1.jsx)(material_1.Typography, { "data-testid": "source-card-name", variant: "body1", children: sourceCard?.name })) : isSourceCardLoading ? ((0, jsx_runtime_1.jsx)(bouncingLoaderComp_1.default, {})) : ((0, jsx_runtime_1.jsx)(material_1.Typography, { sx: [
                                {
                                    textTransform: 'uppercase',
                                },
                                globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                    ? {
                                        fontWeight: 400,
                                        fontSize: '12px',
                                        color: '#000000',
                                        textTransform: 'none',
                                    }
                                    : {},
                            ], variant: "body1", children: "N/A" }))] }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { sx: { padding: theme.tsGoUnit.tsUnitHalf }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { sx: [
                                {
                                    textTransform: 'uppercase',
                                },
                                globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                    ? {
                                        fontWeight: 500,
                                        fontSize: '12px',
                                        color: '#000000',
                                        textTransform: 'none',
                                    }
                                    : {},
                            ], variant: "subtitle2", children: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? strings_1.walletStrings.VIRTUAL_CARD_CAN_BE_USED_UNTIL
                                : strings_1.walletStrings.VIRTUAL_CARD_END_DATE }), (0, jsx_runtime_1.jsx)(material_1.Typography, { sx: [
                                {
                                    textTransform: 'uppercase',
                                },
                                globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                    ? {
                                        fontWeight: 400,
                                        fontSize: '12px',
                                        color: '#000000',
                                        textTransform: 'none',
                                    }
                                    : {},
                            ], variant: "body1", children: (0, virtualCard_1.getCardValidEndingOnDate)(card?.card?.validEndingOn) })] }), globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsxs)(material_1.Stack, { sx: { padding: theme.tsGoUnit.tsUnitHalf }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { sx: [
                                {
                                    textTransform: 'uppercase',
                                },
                                globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                    ? {
                                        fontWeight: 500,
                                        fontSize: '12px',
                                        color: '#000000',
                                        textTransform: 'none',
                                    }
                                    : {},
                            ], variant: "subtitle2", children: 'Card type' }), (0, jsx_runtime_1.jsx)(material_1.Typography, { "data-testid": "source-card-name", variant: "body1", children: (0, virtualCard_1.getVirtualCardTypeLabel)({
                                card: card?.card,
                                fields: card?.context?.request.fields,
                            }) })] })) : null] }) }));
};
exports.default = WalletDetailAside;
